import React from 'react';
import Accordion from '../Accordion/Accordion';
import { ReactComponent as FootballSvg } from '../../svg/football.svg';
import { ReactComponent as BasketballSvg } from '../../svg/basketball.svg';
import { ReactComponent as TennisSvg } from '../../svg/tennis.svg';
import { ReactComponent as CupSvg } from '../../svg/cup.svg';
import { ReactComponent as CasinoSvg } from '../../svg/casino.svg';
import { ReactComponent as RouletteSvg } from '../../svg/roulette.svg';
import { ReactComponent as SlotsSvg } from '../../svg/slots.svg';
import { ReactComponent as MmaSvg } from '../../svg/mma.svg';
import { ReactComponent as TableTennisSvg } from '../../svg/table-tennis.svg';
import { ReactComponent as CricketSvg } from '../../svg/cricket.svg';
import { ReactComponent as HockeySvg } from '../../svg/hockey.svg';
import { ReactComponent as BaseballSvg } from '../../svg/baseball.svg';

const Sidebar = () => {
  const casinoContent = [
    {
      label: 'Roulette',
      path: '',
      icon: <RouletteSvg />,
    },
    {
      label: 'Slots',
      path: '',
      icon: <SlotsSvg />,
    },
  ];
  const sportsBookContent = [
    {
      label: 'Football',
      path: '/football/live',
      icon: <FootballSvg />,
    },
    {
      label: 'Basketball',
      path: '/basketball/live',
      icon: <BasketballSvg />,
    },
    {
      label: 'Tennis',
      path: '/tennis/live',
      icon: <TennisSvg />,
    },
    {
      label: 'Cricket',
      path: '/cricket/live',
      icon: <CricketSvg />,
    },
    {
      label: 'Baseball',
      path: '/baseball/live',
      icon: <BaseballSvg />,
    },
    {
      label: 'Ice-Hockey',
      path: '/ice-hockey/live',
      icon: <HockeySvg />,
    },
    {
      label: 'MMA',
      path: '/mma/live',
      icon: <MmaSvg />,
    },
    {
      label: 'Table tennis',
      path: '/table-tennis/live',
      icon: <TableTennisSvg />,
    },
  ];
  return (
    <aside>
      <Accordion
        title={'Casino'}
        titleIcon={<CasinoSvg />}
        content={casinoContent}
      />
      <Accordion
        title={'Sportsbook'}
        titleIcon={<CupSvg />}
        content={sportsBookContent}
      />
      <Accordion title={'Live RTP'} />
      <Accordion
        content={[
          {
            label: 'Promotions',
            path: '#',
            icon: '',
          },
          {
            label: 'Refer & earn',
            path: '#',
            icon: '',
          },
          {
            label: 'Redeem',
            path: '#',
            icon: '',
          },
        ]}
      />
      <Accordion title={'VIP-Club'} />
      <Accordion title={'Live Support'} />
      <Accordion
        title={'English'}
        content={[
          {
            label: 'English (Indian)',
            icon: '',
          },
          {
            label: 'Português',
            icon: '',
          },
          {
            label: 'Srpski',
            icon: '',
          },
          {
            label: 'Türkçe',
            icon: '',
          },
          {
            label: 'Pyccкий',
            icon: '',
          },
        ]}
      />
    </aside>
  );
};

export default Sidebar;
